export default __webpack_public_path__ + "static/media/c001-student-4.e9eddde0.jpg";